export const AppStoreIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_2050)">
      <path
        d="M19.3825 0.5H5.07847C2.39947 0.5 0.230469 2.669 0.230469 5.348V19.655C0.230469 22.331 2.39947 24.5 5.07847 24.5H19.3855C22.0615 24.5 24.2335 22.331 24.2335 19.652V5.348C24.2305 2.669 22.0615 0.5 19.3825 0.5Z"
        fill="url(#paint0_linear_1_2050)"
      />
      <path
        d="M12.128 6.01385L12.614 5.17385C12.914 4.64885 13.583 4.47185 14.108 4.77185C14.633 5.07185 14.81 5.74085 14.51 6.26585L9.82702 14.3718H13.214C14.312 14.3718 14.927 15.6618 14.45 16.5558H4.52002C3.91402 16.5558 3.42802 16.0698 3.42802 15.4638C3.42802 14.8578 3.91402 14.3718 4.52002 14.3718H7.30402L10.868 8.19485L9.75502 6.26285C9.45502 5.73785 9.63202 5.07485 10.157 4.76885C10.682 4.46885 11.345 4.64585 11.651 5.17085L12.128 6.01385ZM7.91602 17.6808L6.86602 19.5018C6.56602 20.0268 5.89702 20.2038 5.37202 19.9038C4.84702 19.6038 4.67002 18.9348 4.97002 18.4098L5.75002 17.0598C6.63202 16.7868 7.34902 16.9968 7.91602 17.6808ZM16.958 14.3778H19.799C20.405 14.3778 20.891 14.8638 20.891 15.4698C20.891 16.0758 20.405 16.5618 19.799 16.5618H18.221L19.286 18.4098C19.586 18.9348 19.409 19.5978 18.884 19.9038C18.359 20.2038 17.696 20.0268 17.39 19.5018C15.596 16.3908 14.249 14.0628 13.355 12.5118C12.44 10.9338 13.094 9.34985 13.739 8.81285C14.456 10.0428 15.527 11.8998 16.958 14.3778Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_2050"
        x1="12.232"
        y1="0.5"
        x2="12.232"
        y2="24.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18BFFB" />
        <stop offset="1" stopColor="#2072F3" />
      </linearGradient>
      <clipPath id="clip0_1_2050">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.230469 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
